import { Component, OnInit, Injector } from '@angular/core';
import { socialMediaTabComponent } from '../socialMediaTab/socialMediaTab.component';
import { FacebookService } from 'ngx-facebook';
import { SharedContentClient } from '../../api/DixApiClient';

@Component({
  selector: 'mobile-social-media-tab',
  template: require('./mobile-social-media-tab.component.html'),
  styles: [require('./mobile-social-media-tab.component.css')]
})
export class MobileSocialMediaTabComponent extends socialMediaTabComponent {

  constructor(injector: Injector, protected faceBookService:FacebookService, protected sharedContentClient: SharedContentClient) {
    super(injector, faceBookService, sharedContentClient);
  }


}
